import { useState } from 'react'
import {
  Container,
  Title,
  Text,
  Button,
  SimpleGrid,
  Card,
  Badge,
  Group,
  Stack,
  Box,
  Paper,
  Timeline,
  Divider,
} from '@mantine/core'

// #1080 エントリー(Bizlinker申請)画面。旧実装(entries_page配下のBEM/背景画像ベースのランディング)は
// 参考にせず、既存のMantineコンポーネント運用に合わせて作り直している。
// フォーム送信自体はRails側の実フォーム(#bizlinker-request-form)に任せ、
// このモーダルの送信ボタンはform属性でそのフォームを参照するだけ。

const STRENGTHS = [
  {
    title: 'スキルレベルの高さ',
    description: 'ハイスキルなフリーランサーが登録しているBizlink。他では出会いの難しいプロフェッショナルなフリーランサーに出会えます。',
  },
  {
    title: '豊富な人材',
    description: 'Bizlinkではエンジニアからビジネスコンサルタント・マーケターまで幅広い人材が登録済。あなたのビジネスの加速に欠かせない存在が見つかります。',
  },
  {
    title: '案件登録が簡単',
    description: 'Bizlinkでは登録案件の金額も自由に設定可能。あなたのプロジェクト管理もスムーズに。',
  },
]

const OCCUPATIONS = ['デザイナー', 'エンジニア', 'ディレクター', 'マーケター']

const EXPERTS = [
  { name: 'WEBディレクター代行支援', position: '大手Web制作会社出身ディレクター', description: '大手制作会社で培ったノウハウを活かし、制作・進行の管理や設計、コミュニケーション戦略の立案などプロジェクト全体の指揮、管理を行います。' },
  { name: 'WEBマーケティング支援', position: '外資系コンサル出身マーケター', description: '膨大なデータを調査・分析し、その上で参入すべき市場の選定、プロモーションの手段やツールの検討、計画を行います。' },
  { name: '受託開発案件支援', position: '大手制作会社勤務エンジニア', description: '企画立案やスケジュール管理などのディレクションから、多様な言語(PHP、Ruby on Rails、Java、C#、等)を用いた開発までを行います。' },
  { name: 'WEBディレクター代行支援', position: '大手Web制作会社出身ディレクター', description: '大手制作会社で培ったノウハウを活かし、制作・進行の管理や設計、コミュニケーション戦略の立案など案件全体の指揮、管理を行います。' },
]

const VOICES = [
  { purpose: 'ベンチャー企業の人手不足対策に', name: 'ベンチャー企業 CXO Aさん', title: 'デザイン以外でも実力を発揮してもらいました', body: '自分の会社以外3つの会社にCXOとして参画しており、それぞれの会社で新規サービスを立ち上げる際、こだわったコンセプトの元でデザイン制作を進めることになったが、身近に求めるレベルのデザイナーがいなかった。すぐに稼働可能な方がいるBizlinkで募集し、優秀な方ばかりだったので助かった。前職でマネジメント経験やエンジニアの知識もある方もおり、デザイン以外でもご尽力頂いている。' },
  { purpose: '一人経営会社で案件ごとにアサインするメンバーとして', name: '一人経営会社 社長 Bさん', title: 'エンジニア4名に業務を依頼', body: '同時に複数の案件を常に進行しており、開始時期や期間はそれぞれ違ったが、Bizlinkで1人づつエンジニアを募集。ご応募いただいた全ての方、スキルはもちろん向上心・コミュニケーション能力も高く、他チームメンバーともうまくやって頂いている。' },
  { purpose: '自分が取ってきた案件のプレイヤーとして', name: 'TOPフリーランサー Cさん', title: '優秀なディレクターが柔軟に対応', body: '基本的に企画やお客様との折衝を行い、手を動かしてくれるディレクターを毎回探していたが、案件ごとに求めるスキルが変わり、普通の人材紹介では時間もかかっていた。現在はwebページリニューアルからグラフィックデザインまで、ベースを決めた後しっかり動いてくれるメンバーをアサインでき、常に柔軟に対応してもらえるのは実際凄く助かる。' },
]

const FLOW_STEPS = [
  { title: '簡単5秒申請', description: 'このページの「Bizlinkerとして活動する」ボタンから申請してください。プロフィールの必須項目は全てご入力頂いている事が前提です。' },
  { title: 'スキル、経験から書類審査', description: 'ご登録頂いたスキルやご経歴から、Bizlinkerの書類審査をおこないます。' },
  { title: 'ヒアリング / ご面談', description: 'Bizlinkerのご説明に加え、案件に関しての条件や、ご希望に関してヒアリングさせて頂きます。オンラインのみでなく、対面でのヒアリングも可能です。' },
  { title: '案件登録および交渉サポート', description: '実際の案件をご登録頂き、運用開始となります。' },
  { title: '稼働開始', description: 'プロジェクトのご相談等、Bizlinkerとしての活動を継続的にサポートさせて頂きます。' },
]

const FAQS = [
  { q: 'Bizlinkerでの登録にお金はかかりますか', a: '登録は無料です。基本的に案件が発生した際お支払いとなります。' },
  { q: '個人でも法人でも登録は可能ですか？', a: 'フリーの方は勿論、会社内でのプロジェクトに必要なメンバーを探して頂く事も可能。法人で登録されていらっしゃる会社様もいらっしゃいます。' },
  { q: 'フリーランサーと並行して活動は可能ですか？', a: '勿論可能です。フリーランサーとして活動しながら、ビズリンカーとして複数案件を持っている方も多くいらっしゃいます。' },
]

function SectionHeading({ children, description }) {
  return (
    <Stack gap={4} mb="lg">
      <Title order={2} fz={26}>{children}</Title>
      {description && <Text c="dimmed">{description}</Text>}
    </Stack>
  )
}

function FaqItem({ q, a }) {
  const [opened, setOpened] = useState(false)

  return (
    <Paper withBorder radius="sm" p="md">
      <Box
        role="button"
        tabIndex={0}
        onClick={() => setOpened((o) => !o)}
        onKeyDown={(e) => e.key === 'Enter' && setOpened((o) => !o)}
        style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}
      >
        <Badge circle color="brand" variant="light" size="lg">Q</Badge>
        <Text fw={600} style={{ flex: 1 }}>{q}</Text>
        <span
          className="material-icons"
          style={{ fontSize: 20, color: 'var(--mantine-color-dimmed)', transition: 'transform 150ms ease', transform: opened ? 'rotate(180deg)' : 'rotate(0deg)' }}
        >
          expand_more
        </span>
      </Box>
      <Box style={{ maxHeight: opened ? 200 : 0, overflow: 'hidden', transition: 'max-height 200ms ease' }}>
        <Group align="flex-start" gap={10} pt="sm" wrap="nowrap">
          <Badge circle color="gray" variant="light" size="lg">A</Badge>
          <Text c="dimmed">{a}</Text>
        </Group>
      </Box>
    </Paper>
  )
}

function ApplyModal({ opened, onClose, formId }) {
  if (!opened) return null

  return (
    <Box style={{ position: 'fixed', inset: 0, zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(0, 0, 0, 0.45)' }} />
      <Paper shadow="lg" radius="md" p="xl" style={{ position: 'relative', width: 380, maxWidth: '90vw' }}>
        <Stack align="center" gap="lg">
          <Text fw={600} size="lg" ta="center">ビズリンカーとしての活動を{'\n'}申請しますか？</Text>
          <Group grow w="100%">
            <Button variant="default" onClick={onClose}>いいえ</Button>
            <Button type="submit" form={formId} color="brand">はい</Button>
          </Group>
        </Stack>
      </Paper>
    </Box>
  )
}

export default function EntriesLanding({ formId, alreadySubmitted }) {
  const [modalOpened, setModalOpened] = useState(false)

  if (alreadySubmitted) {
    return (
      <Container size={640} py={80}>
        <Paper withBorder radius="md" p="xl">
          <Stack align="center" gap="md">
            <Badge color="brand" size="lg" variant="light">申請完了</Badge>
            <Text fw={600} size="lg" ta="center">活動申請が完了しました。{'\n'}運営よりのご連絡をお待ちください。</Text>
            <Button component="a" href="/projects" color="brand">案件一覧へ戻る</Button>
          </Stack>
        </Paper>
      </Container>
    )
  }

  return (
    <Container size={960} py="xl">
      <Stack gap={64}>
        {/* Hero */}
        <Paper withBorder radius="md" p={{ base: 'lg', sm: 40 }} style={{ background: 'var(--mantine-color-brand-0)' }}>
          <Stack gap="md" maw={560}>
            <Badge color="brand" variant="filled" w="fit-content">Bizlinker募集中</Badge>
            <Title order={1} fz={{ base: 28, sm: 34 }} style={{ textWrap: 'balance' }}>
              ハイスキルなフリーランスが、あなたのビジネスを加速させる
            </Title>
            <Text c="dimmed" size="lg">実績のあるフリーランスをお探しのあなたに。</Text>
            <Button size="md" color="brand" w="fit-content" onClick={() => setModalOpened(true)}>
              Bizlinkerとして活動する
            </Button>
          </Stack>
        </Paper>

        {/* About */}
        <Box id="about">
          <SectionHeading>Bizlinkerとは</SectionHeading>
          <Text size="lg">
            フリーランサーを集める「<Text span fw={700} c="brand.7" inherit>Bizlinker</Text>」として案件を登録し、
            あなたのビジネスを加速させるハイレベルフリーランサーと出会いましょう。
          </Text>
        </Box>

        {/* 3つの強み */}
        <Box id="advantage">
          <SectionHeading description="Bizlinkで、エンジニア・デザイナー・マーケター等を募集、プロフェッショナルなメンバーでプロジェクトを進行する事が可能です。">
            Bizlink 3つの強み
          </SectionHeading>
          <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="md">
            {STRENGTHS.map((item) => (
              <Card key={item.title} withBorder radius="md" padding="lg">
                <Text fw={700} mb={6}>{item.title}</Text>
                <Text size="sm" c="dimmed">{item.description}</Text>
              </Card>
            ))}
          </SimpleGrid>
        </Box>

        {/* 職種 */}
        <Box>
          <Text fw={700} mb="sm">Bizlink登録者の職種</Text>
          <Group gap="xs" mb="xs">
            {OCCUPATIONS.map((job) => (
              <Badge key={job} size="lg" variant="outline" color="brand">{job}</Badge>
            ))}
          </Group>
          <Text size="sm" c="dimmed">その他にも……プロデューサー・プランナー・ライター・エディター・ビジネスコンサルタントなど</Text>
        </Box>

        {/* エキスパート事例 */}
        <Box>
          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
            {EXPERTS.map((expert, i) => (
              <Card key={i} withBorder radius="md" padding="lg">
                <Text fw={700}>{expert.name}</Text>
                <Text size="xs" c="dimmed" mb={8}>{expert.position}</Text>
                <Text size="sm">{expert.description}</Text>
              </Card>
            ))}
          </SimpleGrid>
        </Box>

        <Divider />

        {/* お客様の声 */}
        <Box>
          <SectionHeading>ご利用者様の声</SectionHeading>
          <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="md">
            {VOICES.map((voice) => (
              <Card key={voice.name} withBorder radius="md" padding="lg">
                <Stack gap={4} mb="sm">
                  <Text size="xs" c="dimmed">{voice.purpose}</Text>
                  <Text size="xs" fw={600}>{voice.name}</Text>
                </Stack>
                <Text fw={700} size="sm" mb={6}>{voice.title}</Text>
                <Text size="sm" c="dimmed" lineClamp={6}>{voice.body}</Text>
              </Card>
            ))}
          </SimpleGrid>
        </Box>

        {/* 流れ */}
        <Box id="flow">
          <SectionHeading>案件運用開始までの流れ</SectionHeading>
          <Timeline bulletSize={28} lineWidth={2} color="brand">
            {FLOW_STEPS.map((step, index) => (
              <Timeline.Item
                key={step.title}
                title={step.title}
                bullet={<Text size="xs" fw={700} c="brand.7">{index + 1}</Text>}
              >
                <Text size="sm" c="dimmed">{step.description}</Text>
              </Timeline.Item>
            ))}
          </Timeline>
        </Box>

        {/* FAQ */}
        <Box id="faq">
          <SectionHeading>よくあるご質問</SectionHeading>
          <Stack gap="xs">
            {FAQS.map((faq) => (
              <FaqItem key={faq.q} q={faq.q} a={faq.a} />
            ))}
          </Stack>
        </Box>

        {/* Contact CTA */}
        <Paper withBorder radius="md" p={{ base: 'lg', sm: 40 }} style={{ background: 'var(--mantine-color-brand-0)' }}>
          <Stack align="center" gap="sm" ta="center">
            <Title order={2} fz={22}>簡単5秒申請</Title>
            <Text c="dimmed" maw={480}>
              新規登録はこちらから。登録審査を通過されたBizlinkerの方を順番に、ご面談させて頂いております。
              多くのご応募を頂いているため、ご連絡をお待ち頂く場合もございます、どうぞご了承ください。
            </Text>
            <Button size="md" color="brand" onClick={() => setModalOpened(true)}>
              Bizlinkerとして活動する
            </Button>
          </Stack>
        </Paper>
      </Stack>

      <ApplyModal opened={modalOpened} onClose={() => setModalOpened(false)} formId={formId} />
    </Container>
  )
}
